import AxiosConfig from "@/config/axiosConfig/AxiosConfig";
import config from "@/config";


const JobService = {
    getJob: async (page) => {
        try {
            const response = await AxiosConfig.get(config.api.job + 'HotList');
            return response.data;
        } catch (error) {
            console.error('Error:', error);
            return Promise.reject(error);
        }
    },

    getMajorList: async (page) => {
        try {
            const response = await AxiosConfig.get(config.api.job + 'MajorList');
            return response.data;
        } catch (error) {
            console.error('Error:', error);
            return Promise.reject(error);
        }
    },

    getQuery: async (params) => {
        try {
            const response = await AxiosConfig.get(config.api.job + 'query', { params });
            return response.data;
        } catch (error) {
            console.error('Error:', error);
            return Promise.reject(error);
        }
    },

    getJobById: async (id) => {
        try {
            const response = await AxiosConfig.get(config.api.job + `${id}`);
            return response.data;
        } catch (error) {
            console.error('Error:', error);
            return Promise.reject(error);
        }
    },

    getJobByCompany: async (id, params) => {
        try {
            const response = await AxiosConfig.get(config.api.job + `ByCompany/${id}`, { params });
            return response.data;
        } catch (error) {
            console.error('Error:', error);
            return Promise.reject(error);
        }
    },

    getJobWithPagination: async (page, pageSize) => {
        try {
            const response = await AxiosConfig.get(config.api.job + `Urgent?page=${page}&pageSize=${pageSize}`);
            return response.data;
        } catch (error) {
            console.error('Error:', error);
            return Promise.reject(error);
        }
    }
};
export default JobService;